export const getStateWithOnlyOneLevel = (state, levelOne) => state[levelOne];
